import React, { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import galleryadd from "../../../src/assests/images/gallery-add.svg";
import close from "../../../src/assests/images/close-circle.svg";
import { useTaskContext } from "../store/AlltasksContext";

interface FileuploadProps {
  iconSrc?: string;
  onFileSelect?: (file: File | null) => void;
  previewSize?: { width: number; height: number };
  onRemoveFile?: () => void;
  fileuploadclass?: string;
  fileuploadstyle?: React.CSSProperties;
  previewImage?: string; // For pre-existing images (e.g., smallimage)
  initialImage?: string;
}

const Fileupload: React.FC<FileuploadProps> = ({
  iconSrc = galleryadd,
  onFileSelect,
  previewSize = { width: 24, height: 24 },
  onRemoveFile,
  fileuploadclass = "",
  fileuploadstyle = {},
  previewImage,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const fileInputRef = React.createRef<HTMLInputElement>();
  const { activeStep } = useTaskContext();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
      if (onFileSelect) onFileSelect(selectedFile); // Trigger handleSmallImageUpload
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        setPreviewUrl(fileReader.result as string);
      };
      fileReader.readAsDataURL(selectedFile);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setPreviewUrl(null);
    if (onRemoveFile) onRemoveFile();
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Use previewUrl (local upload) or previewImage (default/pre-existing)
  const displayImage = previewUrl || previewImage;

  return (
    <Box className={fileuploadclass} style={fileuploadstyle}>
      {!displayImage && (
        <Tooltip
          title="Add Image"
          sx={{
            "& .MuiTooltip-tooltip": {
              backgroundColor: "#000",
              color: "#fff",
              fontSize: "12px",
            },
          }}
        >
          <IconButton
            sx={{
              padding: "16px",
              "&:hover": { backgroundColor: "transparent !important" },
              ".MuiTouchRipple-root": { display: "none" },
            }}
            onClick={() => fileInputRef.current?.click()}
          >
            <img
              src={iconSrc}
              alt="Upload"
              crossOrigin="anonymous"
              width={previewSize.width}
              height={previewSize.height}
            />
          </IconButton>
        </Tooltip>
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {displayImage && (
        <Box
          className="uploadedimg"
          sx={{
            position: "relative",
            background: "#FFF",
            borderRadius: "50%",
            padding: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            className="privew-img"
            src={displayImage}
            alt="Preview"
            style={{ width: previewSize.width, height: previewSize.height }}
            crossOrigin={previewImage && !previewUrl ? "anonymous" : undefined}
          />
          <IconButton
            className="cancelicon"
            sx={{
              position: "absolute",
              top: "-11px",
              right: "-7px",
              padding: "4px",
              background: "#FFF",
              boxShadow: "none",
            }}
            onClick={handleRemoveFile}
          >
            <img width={12} height={12} src={close} alt="x" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default Fileupload;